import { render, staticRenderFns } from "./GpEmptyPage.vue?vue&type=template&id=4498917e&scoped=true&"
import script from "./GpEmptyPage.vue?vue&type=script&lang=js&"
export * from "./GpEmptyPage.vue?vue&type=script&lang=js&"
import style0 from "./GpEmptyPage.vue?vue&type=style&index=0&id=4498917e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498917e",
  null
  
)

export default component.exports